module.exports = __webpack_public_path__ + "h5/img/logo2.7c6dda30.png";